import { Injectable } from "@angular/core";
import { Client, Message, Stomp } from "@stomp/stompjs";
import { environment } from "environments/environment";
import { BehaviorSubject } from "rxjs/internal/BehaviorSubject";
import * as SockJS from 'sockjs-client';
import { AppStateConstant } from "../../constants/AppState.constant";

@Injectable({
  providedIn: 'root'
})
export class SocketService {
  private stompClient: Client;
  message$ = new BehaviorSubject(null);

  constructor() {
  }

  sendMessage(message: string) {
    this.stompClient.publish({ destination: '/app/send/message', body: message });
  }

  initializeWebSocketConnection() {
    const serverUrl = environment.SOCKET_ENDPOINT;
    let token = localStorage.getItem(AppStateConstant.ServerToken);
    if (!token || token === 'null') {
      console.error('No token found');
      return;
    }
    if (this.stompClient && this.stompClient?.connected) {
      // console.log('Already connected');
      return;
    }
    // const ws = new SockJS(serverUrl, null, {
    //     headers: {
    //         "Authorization": 'Bearer ' + token
    //     }
    // });
    const ws = new SockJS(serverUrl);

    this.stompClient = Stomp.over(ws);

    this.stompClient.configure({
      reconnectDelay: 5000, // Reconnect after 5 seconds if connection is lost
      heartbeatIncoming: 4000, // Check server every 4 seconds
      heartbeatOutgoing: 4000, // Send heartbeat every 4 seconds
      connectHeaders: {
        Authorization: `Bearer ${token}`
      },
      onConnect: (frame) => {
        // console.log('Connected: ' + frame);
        if (!this.message$) {
          this.message$ = new BehaviorSubject(null);
        }
        // Subscribe to /topic/messages
        // this.stompClient.subscribe('/topic/messages', (message: Message) => {
        //   if (message.body) {
        //     // console.log('Received from /topic/messages: ' + message.body);
        //     this.message$.next(message.body);
        //   }
        // });

        // Subscribe to /topic/notification
        this.stompClient.subscribe('/topic/notification', (message: Message) => {
          if (message.body) {
            // console.log('Received from /topic/notification: ' + message.body);
            this.message$?.next(message.body);
          }
        });
      },
      onStompError: (frame) => {
        console.error('Broker reported error: ' + frame.headers['message']);
        console.error('Additional details: ' + frame.body);
      },
      onWebSocketClose: (event) => {
        console.error('WebSocket closed: ' + event);
      },
      onWebSocketError: (event) => {
        console.error('WebSocket error: ' + event);
      }
    });

    this.stompClient.activate();
  }

  disconnect() {
    if (this.stompClient) {
      this.stompClient.deactivate();
      this.stompClient.forceDisconnect();
      this.stompClient = null;
    }
    // if (this.message$) {
    //   this.message$.unsubscribe();
    //   this.message$ = null;
    // }
  }
}